module.exports = __webpack_public_path__ + "img/thehairdressers.7a6d5afa.jpg";